import Formula from 'fparser'

import { castToFloat } from './string-helpers'

type ValueObject = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  [key: string]: number | string | Function | ValueObject
}

/**
 * Parse a formula and return the result
 * Will work with any combination of decimal and thousand separators
 * In case of error, return 0
 * @param formula - The formula to parse
 * @param options - The variables to pass to the parser
 * @returns - The result of the formula
 */
export const parseFormula = (
  formula: string,
  options: ValueObject = {}
): string | number | (string | number)[] => {
  const intFormula = formula.replace(/(\d[\d.,]*)/g, (match) => {
    // Convert each number to a float to avoid issues with thousand/decimal separators
    return castToFloat(match).toString()
  })

  try {
    const parser = new Formula(intFormula)
    return parser.evaluate(options)
  } catch {
    return 0
  }
}
